<template>
    <div>
      <div id="tips" v-show="tipsShow">
         <img src="./images/jt.png" class="jt">
         <div class="sb">
           <img src="./images/1.png"> 点击右上角的 •••
         </div>
         <div class="sb">
           <img src="./images/2.png"> 选择“在浏览器中打开”
         </div>
     </div>
    </div>
   </template>
   <script>
     /* eslint-disable */
   import ajax from '@/common/ajax/ajax'
   export default {
     data() {
       return {
         tipsShow: false,
         url:''
       }
     },
     created() {
       this.download()
     },
     methods: {
       isMobile(){
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        if(flag === null){
          flag = false
        } else {
          flag = true
        }
        return flag
       },
       async download() {
         const isMobile = this.isMobile()
         let tempPage
         console.log(isMobile,'-------------');
         if(!isMobile){
           tempPage=window.open("", "_blank");
         }
        let res = null
        let iosUrl = null
        let androidUrl = null
        ajax.getAppDownloadConfig().then(data=>{
            res = JSON.stringify(data.data)
            const regexIos=/\iosUrl:'(.+?)\'/g;
            const regexAnd=/\androidUrl:'(.+?)\'/g;
            let result
            while((result=regexIos.exec(res))!=null) {
                console.log(iosUrl,'iosUrl');
                iosUrl = result[1]
            }
            while((result=regexAnd.exec(res))!=null){
                androidUrl = result[1]
            }

            console.log(androidUrl,'androidUrl');
            const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            const url = isiOS ? `http://m.kiiik.com/${iosUrl}` : androidUrl;
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger\/[0-9]/i) || ua.match(/QQ\/[0-9]/i)) {
              this.tipsShow = true
            } else {
              // 手机系统类型
              if (isiOS) {
                var system = 'IOS';
              } else {
                var system = 'Android';
              }
              // 浏览器判断
              var ua = navigator.userAgent.toLowerCase();
              let btype;
              if (ua.match(/MicroMessenger\/[0-9]/i)) {
                btype = '微信';
              } else if (ua.match(/QQ\/[0-9]/i)) {
                btype = 'QQ';
              } else if (ua.indexOf('mqqbrowser') > -1) {
                btype = 'QQ浏览器';
              } else if (ua.indexOf('opera') > -1) {
                btype = 'Opera浏览器';
              } else if (ua.indexOf('ucbrowser') > -1) {
                btype = 'UC浏览器';
              } else if (ua.indexOf('baiduboxapp') > -1) {
                btype = '百度浏览器';
              } else if (ua.indexOf('chrome') > -1) {
                btype = 'chrome浏览器';
              } else if (ua.indexOf('safari') > -1) {
                btype = 'Safari浏览器';
              } else if (ua.indexOf('firefox') > -1) {
                btype = 'Firefox浏览器';
              } else {
                btype = '其它';
              }

      
            // 上传日志
              setTimeout(() => {
                const repo = 'appNew';
                const token = 'TwFQY3_TmvcIpTqfFW4W6fCfFwN1XiUpJdtCYPhW:yOTlzTrM5VKFHN1L_yyxYMcVLBM=:eyJyZXNvdXJjZSI6Ii92Mi9yZXBvcy9hcHBOZXcvZGF0YSIsImV4cGlyZXMiOjE4Nzc1Nzg5ODIsImNvbnRlbnRNRDUiOiIiLCJjb250ZW50VHlwZSI6InRleHQvcGxhaW4iLCJoZWFkZXJzIjoiIiwibWV0aG9kIjoiUE9TVCJ9';
                const data = [{ system, type: btype, ctype: '下载' }];
                this.pushToPandoraPipeline(repo, token, data);
              }, 200);
              console.log(url,'url');
              // 跳转下载
              setTimeout(function(){
                if(!isMobile){
                  tempPage.location = url
                } else {
                  window.location.href = url;
                }
              },500);
            }
        })
      },
      parseJSON(data){
         // Attempt to parse using the native JSON parser first
         if (window.JSON && window.JSON.parse) {
                    return window.JSON.parse(data);
                }

                //var rx_one = /^[\],:{}\s]*$/,
                //    rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
                //    rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
                //    rx_four = /(?:^|:|,)(?:\s*\[)+/g,
                var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;

                //var json;

                var text = String(data);
                rx_dangerous.lastIndex = 0;
                if (rx_dangerous.test(text)) {
                    text = text.replace(rx_dangerous, function (a) {
                        return '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                    });
                }

                // todo 使用一下判断,增加安全性
                //if (
                //    rx_one.test(
                //        text
                //            .replace(rx_two, '@')
                //            .replace(rx_three, ']')
                //            .replace(rx_four, '')
                //    )
                //) {
                //    return eval('(' + text + ')');
                //}

                return eval('(' + text + ')');
    },

      createAjax(argument){
        var xmlhttp = {};
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                return xmlhttp; 
       },

      pushToPandoraPipeline(repoName, pandoraAuth, data){
            if (typeof data !== "object") {
                    throw new Error("typeof data must be object, instead of " + (typeof data));
                }
                if (data === null) {
                    throw new Error("data cannot be null");
                }
                if (!(data instanceof Array)) {
                    data = [data];
                }
                var protocolAndDomain;
                if (window.location.protocol === 'https:') {
                    protocolAndDomain = "https://pipeline.qiniu.com";
                } else {
                    protocolAndDomain = "http://pipeline.qiniu.com";
                }
                var url = protocolAndDomain + "/v2/repos/" + repoName + "/data";
                var ajax = this.createAjax();
                ajax.open('POST', url, true);
                ajax.setRequestHeader('Content-type', 'text/plain');
                ajax.setRequestHeader('Authorization', 'Pandora ' + pandoraAuth);

                var dataLines = [];
                for (var i = 0; i < data.length; ++ i) {
                    var lineObj = data[i];
                    var cells = [];
                    for (var key in lineObj) {
                        cells.push(key + "=" + lineObj[key]);
                    }
                    dataLines.push(cells.join('\t'));
                }
                var textData = dataLines.join('\n');
                var that = this;

                ajax.onreadystatechange = function () {
                    if (ajax.readyState === 4) {
                        var resultJSON;
                        try {
                            resultJSON = that.parseJSON(ajax.responseText);
                        } catch (e) {
                            resultJSON = null;
                        }
                        if (ajax.status === 200) {
                            console.debug("[STATISTICS] successfully push data to pandora pipeline.");
                        } else {
                            var errorMessage;
                            if (resultJSON && resultJSON["error"]) {
                                errorMessage = resultJSON["error"];
                            } else {
                                errorMessage = "unknown reason";
                            }
                            console.debug("[STATISTICS] push data to pandora pipeline failed with status " + ajax.status + " : " + errorMessage);
                        }
                    }
                };
                ajax.send(textData);
       }
    }
}

   </script>
   
   <style scoped>
   #tips{
    height: 100vh;
    background: #000;
    opacity: 0.6;
    text-align: right;
  }
  .jt{
      margin-right: 30px;
      margin-top: 20px;
      width: 28%;
  }
  .sb{
    color: #fff;
    text-align: left;
    margin-left: 25%;
    margin-bottom: 20px;
  }
  .sb img{
    width: 24px;
    position: relative;
    top:6px; 
    margin-right: 5px;   
  }
   </style>
   


// WEBPACK FOOTER //
// download.vue?6a8e35a4